import { __assign, __rest } from "tslib";
import React from 'react';
import { useProviderContext } from '@rmwc/provider';
import { Tag, useClassNames, createComponent } from '@rmwc/base';
/** The Typography Component */
export var Typography = createComponent(function Typography(props, ref) {
    var _a;
    var use = props.use, rest = __rest(props, ["use"]);
    var providerContext = useProviderContext();
    var typographyOptions = providerContext.typography;
    var tag = (typographyOptions === null || typographyOptions === void 0 ? void 0 : typographyOptions[use]) || (typographyOptions === null || typographyOptions === void 0 ? void 0 : typographyOptions.defaultTag) || 'span';
    var className = useClassNames(props, [
        (_a = {},
            _a["mdc-typography--" + props.use] = props.use,
            _a)
    ]);
    return React.createElement(Tag, __assign({ tag: tag }, rest, { ref: ref, className: className }));
});
